<div class="main">
  <mat-slider showTickMarks
              [min]="-1"
              [max]="1"
              [step]="0.1"

  >
    <input matSliderThumb [(ngModel)]="value">
  </mat-slider>
  <div
    [style.background-color]="color()"
    class="box">{{ value() | number : '1.2-2' : 'sv' }}
  </div>
  <div>{{ color() }}</div>
  <mat-chip-listbox multiple [(ngModel)]="items">
    <mat-chip-option [value]="0">Bolånekund</mat-chip-option>
    <mat-chip-option [value]="1">Privat</mat-chip-option>
    <mat-chip-option [value]="2">Företag</mat-chip-option>
  </mat-chip-listbox>
  {{ items() | json }}
</div>